
export const setRedirects = (redirects) => {
    const { redirectNewUser, redirect } = redirects
    redirectNewUser ? localStorage.setItem('_ltrnu', redirectNewUser) : localStorage.removeItem('_ltrnu')     //Login Tapit Redirect New user
    redirect ? localStorage.setItem('_ltru', redirect) : localStorage.removeItem('_ltru')      //Login Tapit Redirect user
}